export default __webpack_public_path__ + "static/media/sagar-sachdeva.30513a8b.jpg";